import React from 'react';
import FeatureTab from './FeatureTab';
import TemporaryDashboardTabs from './TemporaryDashboardTabs';
import {
  TAB_TITLE_TRENDS,
  TAB_TITLE_PROMPT,
  TAB_TITLE_AI_ALERT,
  TAB_TITLE_NOC,
} from 'utils/constants';
import renderShared from '@components/common/Dashboard/SharedTabs';
import AccessWrapper from './AccessWrapper';
import SavedDashboardsTab from './SavedDashboardsTab';
import featureNames from '@utils/featureToggle/constants';
import DashboardList from './DashboardList';
import { useSelector } from 'react-redux';
import { appExperienceShareAndSaveSelector } from '@store/common/selectors';
import { appAIAlertEnabledSelector } from '@utils/appInsights';
import UseCases from '../UseCases';

const AppTabs = ({ shareId }) => {
  const renderSharedTab = renderShared(shareId);
  const appExperienceShareAndSaveFeature = useSelector(appExperienceShareAndSaveSelector);

  const isAppAlertEnabled = useSelector(appAIAlertEnabledSelector);

  return (
    <>
      <UseCases />
      <FeatureTab
        tabKey="app-experience"
        isGA
        feature={null}
        tabTitle={TAB_TITLE_TRENDS}
        route="/dashboard/app-experience"
        exact
      />

      <FeatureTab
        tabKey="user-timeline"
        isGA
        feature={null}
        tabTitle="Users"
        route="/dashboard/user-timeline"
        exact
      />
      <FeatureTab
        tabKey="sankey"
        isNewFeature
        isGA={false}
        feature={featureNames.APP_SANKEY}
        tabTitle="Event Pattern"
        route="/dashboard/sankey"
        exact={false}
      />

      <FeatureTab
        tabKey="funnel"
        isNewFeature
        isGA={false}
        feature={featureNames.APP_FUNNEL}
        tabTitle="Funnel"
        route="/dashboard/funnel"
        exact
      />

      <FeatureTab
        tabKey="real-time"
        isGA
        feature={featureNames.NOC}
        tabTitle={<span>{TAB_TITLE_NOC}</span>}
        route="/dashboard/real-time"
        exact
      />

      {isAppAlertEnabled ? (
        <FeatureTab
          tabKey="ai-alerts"
          isGA
          feature={null}
          tabTitle={TAB_TITLE_AI_ALERT}
          route="/dashboard/ai-alerts"
          exact
        />
      ) : null}

      <FeatureTab
        tabKey="prompt"
        isGA={false}
        feature={featureNames.PROMPT}
        tabTitle={TAB_TITLE_PROMPT}
        route="/dashboard/prompt"
        exact
      />

      {appExperienceShareAndSaveFeature ? (
        <AccessWrapper feature={featureNames.SAVED_DASHBOARDS}>
          <SavedDashboardsTab />
        </AccessWrapper>
      ) : null}

      <TemporaryDashboardTabs renderSharedTab={renderSharedTab} activeId={`${shareId}`} />
      {appExperienceShareAndSaveFeature ? <DashboardList id={`${shareId}`} /> : null}
    </>
  );
};

export default AppTabs;
